export default __webpack_public_path__ + "static/media/wr_1.370cf9b4.jpg";